//
// Copyright 2022 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Typography from "@material-ui/core/Typography";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import Portal from "@material-ui/core/Portal";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Box from "@material-ui/core/Box";
import AutomateJobsTable from "src/components/loader/table/AutomateJobsTable";
import YesNoDialog from "eai-configurator-ui/components/configuration/dialog/YesNoDialog";
import * as Utils from "eai-configurator-ui/components/Utils";

const AutomateJobsPage = ({encryptLoaderFiles}) => {
  //
  // State
  const [alertMessage, setAlertMessage] = React.useState(null);
  const [tableRefreshCounter, setTableRefreshCounter] = React.useState(0);

  const [runDeleteJob, setRunDeleteJob] = React.useState({})
  const [runDeleteJobDialogOpen, setRunDeleteJobDialogOpen] = React.useState(false)

  const handleDeleteJobDialog = (job) => {
    setRunDeleteJob(job)
    setRunDeleteJobDialogOpen(true);
  };

  const handleDeleteJobNow = (execute) => {
    setRunDeleteJobDialogOpen(false);

    if (execute === true) {
      if (runDeleteJob == null || runDeleteJob.jobTaskKey == null) {
        setAlertMessage({message: "Failed to find the database to run the jobs", success: false});
        return;
      }

      Utils.fetchData(
        "loader/deleteAutomationJob?jobTaskKey=" + runDeleteJob.jobTaskKey,
        false,
        null,
        false,
        false
      ).catch(function (response) {
        Utils.getErrorMessage(response, "Request failed.").then(setAlertMessage);
      });

      setAlertMessage({message: "Jobs have been submitted for deletion", success: true})
      setTableRefreshCounter(tableRefreshCounter + 1);
    }
  };

  return (
    <React.Fragment>
      <div>
        <Typography variant="body2" color="textSecondary">
          <h5>Automate Jobs</h5>
          <hr/>
        </Typography>
        <Typography variant="body2" color="textSecondary">
          <h6>View the job history</h6>
        </Typography>
        <Typography variant="caption" color="textSecondary">
          In this dialog, you can view the job execution history and you can download a zip file with the
          files exported for a database on a given day. This dialog shows the daily history for a given database, even if multiple
          jobs were executed during that day.
        </Typography>
        {encryptLoaderFiles && (
          <>
            <p/>
            <Typography variant="caption" color="textSecondary">
              Job files generated by the P6-Loader are encrypted on the server, and must be transformed prior to being downloaded.
              The decryption happens after this transformation takes place.
              There will be a delay after clicking the [Download] button while this process takes place.
            </Typography>
          </>
        )}
        <p/>
        {alertMessage && (
          <Portal>
            <Snackbar
              open={alertMessage}
              autoHideDuration={6000}
              onClose={() => setAlertMessage(null)}
            >
              <Alert
                onClose={() => setAlertMessage(null)}
                severity={
                  alertMessage && alertMessage.success ? "success" : "error"
                }
              >
                {alertMessage && (alertMessage.message || "Unknown error")}
              </Alert>
            </Snackbar>
          </Portal>
        )}
        <React.Fragment>
          <Box display="flex" flexDirection="row" justifyContent="flex-end">
            {<AutomateJobsTable
              refreshCounter={tableRefreshCounter}
              setAlertMessage={setAlertMessage}
              handleRemoveJob={handleDeleteJobDialog}
            />}
          </Box>
        </React.Fragment>
      </div>
      <YesNoDialog
        title={"Delete the job?"}
        description={"Are you sure you want to remove this job? " +
          "This will remove all files that were generated from this job execution, as well as all of its tasks. " +
          "The job will be removed in the background and will not disappear from the list of jobs immediately."}
        open={runDeleteJobDialogOpen}
        style={{zIndex: 9999}}
        handleYes={() => handleDeleteJobNow(true)}
        handleNo={() => handleDeleteJobNow(false)}
      />
    </React.Fragment>
  );
};
export default AutomateJobsPage;
